module.exports = __webpack_public_path__ + "img/visa-icon.4f815262.png";